<template>
	<div role="alert" :class="c" :data-type="dataType" data-alert>
		<div>
			<div class="alert__content">
				<p v-html="message"></p>
			</div>
			<ul class="alert__actions">
				<li v-if="alert.dismissable">
					<button class="icon alert__actions__dismiss" v-on:click="$parent.removeAlert(index)">Dismiss</button>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
			}
		},

		props: ['index', 'alert'],

		computed: {
			c() {
				let c = 'alert alert--'
					+ this.alert.type
					+ (this.alert.dismissable ? ' dismissable' : '')
				return c
			},
			dataType() {
				return this.alert.dataType
			},
			message() {
				return this.alert.instances === 1 ?
					this.alert.messages.single :
					_.replace(this.alert.messages.many, '%n', this.alert.instances)
			},
		},

		mounted: function() {
			if (this.alert.autohide) {
				let self = this
				setTimeout(function() {
					self.$parent.removeAlert(this.index)
				}, 7000)
			}
		}
	}
</script>
